/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/UserStatuses.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for User Statuses
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    USERSTATUS_LIST_CONTAINER_LOADED,
    USERSTATUS_LIST_CONTAINER_UNLOADED,
    USERSTATUS_LIST_TABLE_LOADED,
    USERSTATUS_LIST_TABLE_UNLOADED,
    USERSTATUS_SELECT_ROW,
    USERSTATUS_ADD,
    USERSTATUS_EDIT,
    USERSTATUS_DELETE,
    USERSTATUS_OPEN_WARNING,
    USERSTATUS_CLOSE_WARNING,
    USERSTATUS_EDIT_CONTAINER_LOADED,
    USERSTATUS_EDIT_CONTAINER_UNLOADED,
    USERSTATUS_EDIT_FORM_LOADED,
    USERSTATUS_EDIT_FORM_UNLOADED,
    USERSTATUS_EDIT_DATA_LOAD,
    USERSTATUS_EDIT_CONTAINER_SUBMIT,
    USERSTATUS_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeUserStatuses';

const defaultState = {
    refreshList: false,
    userstatuses: [],
    danger: false,
    userstatusid: 0,
    name: '',
    description: '',
    color: '',
    orderid: 0,
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case USERSTATUS_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                userstatuses: action.payload ? action.payload.userstatuses : []
            }
        case USERSTATUS_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case USERSTATUS_SELECT_ROW:
            return {
                ...state,
                userstatusid: action.id
            }
        case USERSTATUS_ADD:
            return {
                ...state
            }
        case USERSTATUS_EDIT:
            return {
                ...state,
                userstatusid: action.id
            }
        case USERSTATUS_DELETE:
            return {
                ...state,
                userstatusid: null
            }
        case USERSTATUS_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case USERSTATUS_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case USERSTATUS_EDIT_CONTAINER_LOADED:
        case USERSTATUS_EDIT_DATA_LOAD:
            return {
                ...state,
                userstatusid: action.payload ? action.payload.userstatusid : 0,
                name: action.payload ? action.payload.name : '',
                description: action.payload ? action.payload.description : '',
                color: action.payload ? action.payload.color : '',
                orderid: action.payload ? action.payload.orderid : 0,
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case USERSTATUS_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case USERSTATUS_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case USERSTATUS_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case USERSTATUS_LIST_CONTAINER_UNLOADED:
        case USERSTATUS_LIST_TABLE_UNLOADED:
        case USERSTATUS_EDIT_CONTAINER_UNLOADED:
        case USERSTATUS_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/UserStatuses.js